import { render, staticRenderFns } from "./DialogAddDefaultBackupContact.vue?vue&type=template&id=cb64467c&scoped=true&"
import script from "./DialogAddDefaultBackupContact.vue?vue&type=script&lang=ts&"
export * from "./DialogAddDefaultBackupContact.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb64467c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
